var map = {
	"./juniorGolf1.jpeg": 1674,
	"./juniorGolf2.jpg": 5658,
	"./juniorGolf3.jpg": 3399,
	"./juniorGolf4.jpeg": 9221,
	"./juniorGolf5.jpg": 2377,
	"./juniorGolf6.jpeg": 1691,
	"./juniorGolf7.jpg": 155,
	"./series1.jpeg": 2210,
	"./series2.jpeg": 9519,
	"./series3.jpeg": 4920,
	"./series4.jpeg": 2045,
	"./series5.jpeg": 7030,
	"./series6.jpeg": 1443,
	"./series7.jpeg": 9164,
	"./spartan1.png": 7471,
	"./spartan2_optimized_.png": 8559,
	"./spartan3.png": 4509,
	"./spartan4.jpeg": 7299,
	"./spartan5.jpeg": 3212,
	"./spartan6.jpeg": 3085
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6551;